import styles from "./contactInfoWithIcon.module.scss";

interface IContactInfoWithIcon {
	icon: React.ReactNode;
	contact: string;
	contactDetail?: React.ReactNode;
	isTel?: boolean;
	onClick?: () => void;
	target?: string;
	link?: string;
}

const ContactInfoWithIcon = ({ icon, contact, isTel, contactDetail, onClick, target, link }: IContactInfoWithIcon): JSX.Element => {
	return (
		<div className={styles.contactContainer}>
			{icon}
			<div className={styles.contactTextBox}>
				{isTel ? (
					<a href={isTel && `tel:+55${contact}`}>
						<strong>{contact}</strong>
					</a>
				) : (
					<a href={link} rel="noreferrer nofollow" onClick={onClick} target={target}>
						<strong>{contact}</strong>
					</a>
				)}
				{contactDetail && <p>{contactDetail}</p>}
			</div>
		</div>
	);
};

export default ContactInfoWithIcon;
